













import { Vue, Component } from 'vue-property-decorator';
import { getRules } from '../api';

@Component
export default class Rules extends Vue {
  obj: any = {};

  async created() {
    const res = await getRules();
    this.obj = res.data;
  }
}
